import React from 'react'
import { SelectFilter } from '../search/SelectFilter'
import { LeftSearchMenuPiece } from '../search/LeftSearchMenuPiece'
import { getSuppliersByCriteria } from '../services/search.service';
import { FILTER_VARIANTS, FILTER_TITLES, FILTER_ID } from '../utils/surveyLiterals';

export const SupplierFilter = ({setSupplierSelected, abortControllerRef}) => {
    
    const handleSupplierSelection = event => {
        if (event)
            setSupplierSelected(event.value)
        else
            setSupplierSelected(null)
    }

    return (
        <LeftSearchMenuPiece>
            <LeftSearchMenuPiece.Item id={FILTER_ID.SUPPLIER} title={FILTER_TITLES.SUPPLIER}>
                <SelectFilter loadOptionsFunction={getSuppliersByCriteria} onChange={handleSupplierSelection} variant={FILTER_VARIANTS.SUPPLIER} abortControllerRef={abortControllerRef}/>
            </LeftSearchMenuPiece.Item>
        </LeftSearchMenuPiece>
    )
}